import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { C3TimeSeriesEdit } from "./edit";
import { C3TimeSeriesNew } from "./new";
import { C3TimeSeriesTable } from "./table";

export default function C3TimeSeries() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Valorisations");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<C3TimeSeriesEdit />} />
      <Route index element={<C3TimeSeriesTable />} />
      <Route path="new" element={<C3TimeSeriesNew />} />
    </Routes>
  );
}
